import React from 'react';
import './CSS/policy.css';

const Disclaimer = () => {
    return (
        <div className="privacy-policy-container">
            <div className="privacy-policy-content">
                <h1>DISCLAIMER – Sri Sairam Advertising</h1>
                <p className="effective-date">Effective Date: 23 April 2026</p>
                
                <p>
                    The information and services provided by Sri Sairam Advertising, Chennai, Tamil Nadu, are intended for general business and advertising purposes only. By using our website and services, you agree to this Disclaimer.
                </p>

                <hr />

                <section>
                    <h2>1. No Guarantee of Results</h2>
                    <p>Sri Sairam Advertising provides advertising services across newspapers and digital platforms such as Google, Facebook, and Instagram.</p>
                    <p>We do not guarantee:</p>
                    <ul>
                        <li>Leads or inquiries</li>
                        <li>Phone calls</li>
                        <li>Conversions or sales</li>
                        <li>Business growth or return on investment (ROI)</li>
                    </ul>
                    <p>Advertising performance depends on multiple external factors including market demand, competition, audience behavior, budget, content quality, and platform algorithms.</p>
                </section>

                <hr />

                <section>
                    <h2>2. Third-Party Platforms</h2>
                    <p>We work with third-party platforms and publishers such as:</p>
                    <ul>
                        <li>Newspapers</li>
                        <li>Google Ads</li>
                        <li>Meta (Facebook & Instagram)</li>
                    </ul>
                    <p>We are not responsible for:</p>
                    <ul>
                        <li>Platform policy changes</li>
                        <li>Ad disapproval or account suspension</li>
                        <li>Technical issues or downtime</li>
                        <li>Changes in pricing or reach</li>
                    </ul>
                    <p>All such platforms operate under their own terms and policies.</p>
                </section>

                <hr />

                <section>
                    <h2>3. Content Responsibility</h2>
                    <p>Clients are fully responsible for the content they provide, including:</p>
                    <ul>
                        <li>Accuracy of information</li>
                        <li>Legal compliance</li>
                        <li>Copyright and trademark rights</li>
                    </ul>
                    <p>Sri Sairam Advertising is not liable for any legal issues, claims, or losses arising from client-provided content.</p>
                </section>

                <hr />

                <section>
                    <h2>4. Errors & Omissions</h2>
                    <p>While we take reasonable care in preparing and publishing advertisements, we are not responsible for:</p>
                    <ul>
                        <li>Errors in content approved by the client</li>
                        <li>Mistakes due to incorrect information provided</li>
                        <li>Printing or publishing errors by newspapers or platforms</li>
                    </ul>
                </section>

                <hr />

                <section>
                    <h2>5. Limitation of Liability</h2>
                    <p>Sri Sairam Advertising shall not be liable for:</p>
                    <ul>
                        <li>Any direct or indirect business losses</li>
                        <li>Loss of revenue, profits, or opportunities</li>
                        <li>Delays or service interruptions</li>
                    </ul>
                    <p>Our services are provided on a best-effort basis.</p>
                </section>

                <hr />

                <section>
                    <h2>6. External Links</h2>
                    <p>Our website may contain links to third-party websites.</p>
                    <p>We do not control or take responsibility for their content or privacy practices.</p>
                </section>

                <hr />

                <section>
                    <h2>7. Service Availability</h2>
                    <p>We do not guarantee uninterrupted or error-free service.</p>
                    <p>Services may be affected by technical issues, third-party dependencies, or unforeseen circumstances.</p>
                </section>

                <hr />

                <section>
                    <h2>8. Changes to Disclaimer</h2>
                    <p>We may update this Disclaimer at any time without prior notice. Updated versions will be posted on our website.</p>
                </section>

                <hr />

                <section>
                    <h2>9. Contact Us</h2>
                    <div className="contact-info">
                        <p><strong>Sri Sairam Advertising</strong></p>
                        <p>Chennai, Tamil Nadu, India</p>
                        <p>📞 +91 9500037429</p>
                        <p>✉️ info@srisairamadvertising.com</p>
                        <p>🌐 <a href="https://srisairamadvertising.com/">https://srisairamadvertising.com/</a></p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Disclaimer;
